import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg, useRefresh } from "@/lib/api";
import { DatePresets } from "@/components/ReminderDialog";

export const CompleteReminderDialog = ({ reminder, onOpenChange }) => {
  const [outcome, setOutcome] = useState("");
  const [next, setNext] = useState("");
  const refresh = useRefresh();
  useEffect(() => { setOutcome(""); setNext(""); }, [reminder]);

  const save = async () => {
    try {
      await api.post(`/reminders/${reminder.reminder_id}/complete`, { outcome, next_due_at: next ? new Date(next).toISOString() : null });
      toast.success(next ? "Completato e nuovo richiamo programmato" : "Richiamo completato");
      refresh();
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={!!reminder} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="max-w-lg" data-testid="complete-reminder-dialog">
        <DialogHeader><DialogTitle className="font-display">Esito richiamo · {reminder?.client_name}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-500">Com'è andata?</Label>
            <Textarea data-testid="complete-outcome" rows={3} value={outcome} onChange={(e) => setOutcome(e.target.value)} placeholder="Es. interessato, invia documenti entro venerdì" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-500">Prossimo richiamo (opzionale)</Label>
            <Input data-testid="complete-next-datetime" type="datetime-local" value={next} onChange={(e) => setNext(e.target.value)} />
            <DatePresets onPick={setNext} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button data-testid="complete-save-btn" onClick={save} className="bg-emerald-600 hover:bg-emerald-700">Segna come fatto</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
